module.exports = __webpack_public_path__ + "img/index-pain-point-4.4cb6ca1a.png";